import { downloadFile } from "../components/FileRender/download";

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadChatAsJson(path: string, name: string) {
  return downloadFile(
    path,
    `${name.replace(/[^a-z0-9]/gi, "-").toLowerCase()}.json`
  );
}
